import styled, { DefaultTheme } from "styled-components";

export type Type = keyof Pick<DefaultTheme["colors"], "success" | "info" | "warning" | "error">;

export const ModalView = styled.div<{
  $type: Type;
}>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.glass.elevated };
  box-shadow: ${({ theme }) => theme.shadow.default };
  border: 1px solid ${({ theme }) => theme.glass.border };
  backdrop-filter: ${({ theme }) => theme.glass.blur };
  border-radius: ${({ theme }) => theme.border_radius.medium }px;
  gap: ${({ theme }) => theme.spacing.x_large }px;
  padding: ${({ theme }) => theme.spacing.xx_medium }px;

  & > div.modal-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 0;

    & > span {
      flex: 1;
      margin-left: ${({ theme }) => theme.spacing.xxx_small }px;

      min-height: ${({ theme }) => theme.font_size.x_large }px;
      font-size: ${({ theme }) => theme.font_size.x_large }px;
      line-height: ${({ theme }) => theme.font_size.x_large }px;
      font-weight: 500;
      color: ${({ theme, $type }) => theme.colors[ $type ].default };
    }
  }

  & > div.modal-body {
    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-weight: 500;
    color: ${({ theme, $type }) => theme.colors.text.default };
  }

  & > div.modal-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing.x_medium }px;
  }
`;
